import styled from '@emotion/styled';

import { type SelectVisualType } from './Select';

type ContainerProps = {
  visualType?: SelectVisualType;
};

export const Container = styled.div<ContainerProps>`
  ${({ visualType, theme }) =>
    visualType === 'fill-rounded' &&
    `
      && {
        .ui-select-selector {
          background-color: ${theme.colors.bgGrayLight};
          border-color: ${theme.colors.bgGrayLight};
          border-radius: 40px;
          color: ${theme.colors.blackSecondary};
          font-weight: 500;
        }
      }
    `};
`;
